import { createMachine } from "xstate";
import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { cancelOrder } from "@nju/data-access-portal-order";

type IEvent =
  | { type: "SUBMIT" }
  | { type: "CANCEL_SUCCESS" }
  | { type: "CANCEL_ERROR" };

interface IContext {
  orchestrator?:
    | IFtthOrchestrator
    | IMultiOrderOrchestrator
    | IMobileOrchestrator
    | IFSecureOrchestrator;
  mode: IOfferModeWithFSecure;
}

export const cancelOrderMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SUBMIT: "send",
        },
      },
      send: {
        invoke: {
          src: "cancelOrder",
        },
        on: {
          CANCEL_SUCCESS: {
            actions: "redirectToDashboard",
            target: "success",
          },
          CANCEL_ERROR: {
            target: "error",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      cancelOrder: ({ orchestrator, mode }) => {
        return async (callback) => {
          try {
            if (!orchestrator?.id) {
              throw new Error("Missing orchestrator.id");
            }

            if (mode === "ftth") {
              await cancelOrder({
                reason: "userRequest",
                orchestratorId: orchestrator.id,
                mode: "ftth",
              });

              return callback({ type: "CANCEL_SUCCESS" });
            }

            if (mode === "fsecure") {
              await cancelOrder({
                reason: "userRequest",
                orchestratorId: orchestrator.id,
                mode: "fsecure",
              });

              return callback({ type: "CANCEL_SUCCESS" });
            }

            if (["mobile", "postpaid"].includes(mode)) {
              await cancelOrder({
                reason: "userRequest",
                orchestratorId: orchestrator.id,
                mode: "multiOrder",
              });

              return callback({ type: "CANCEL_SUCCESS" });
            }
          } catch {
            callback({ type: "CANCEL_ERROR" });
          }
        };
      },
    },
  },
);
